import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Question } from 'src/app/models/question.model';
import { Answer } from 'src/app/models/Answer.model';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { AnswersStore } from 'src/app/store/answers-store';
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';
import { map } from 'rxjs';

@Component({
    selector: 'que-range-question-display',
    imports: [CommonModule, ReactiveFormsModule],
    templateUrl: './range-question-display.component.html',
    styleUrls: ['./range-question-display.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RangeQuestionDisplayComponent {

  @Input()
  question?: Question;
  @Input() viewAnswer = false;

  myAnswer?: Answer;
  answer = new FormControl();
  #answerStore = inject(AnswersStore);
  isUser: boolean = false;
  #questionnaireStore = inject(QuestionnaireStore);
  isNotUser$ = this.#questionnaireStore.isUser$.pipe(map(x => !x));
  numberRange: number[] = Array.from({ length: 10 }, (_, i) => i + 1);
  ngOnInit(): void {
    this.answer.setValidators(this.question?.requierd ? [Validators.required] : null);
    this.isNotUser$.subscribe((isNotUser) => {
      if (isNotUser) {
        this.isUser = false;
      } else {
        this.isUser = true;
      }
    });
    this.answer.valueChanges.subscribe(
      ans => {
        this.#answerStore.updateAnswer({ id: 0, questionId: this.question?.id ?? 0, questionType: this.question?.type.id, intAnswer: ans, isValid: this.answer.valid })
      });

    this.#answerStore.answers$.pipe(map(arr => arr.find(ans => ans.questionId == this.question?.id))).subscribe(x => {
      if (x) {
        this.myAnswer = x;
        this.answer.setValue(x.intAnswer, { emitEvent: false });
      }
    }).unsubscribe();
  }
  select(num: number) {
    if (this.isUser)
      if (this.answer.value == num) {
        this.answer.setValue(null);
      }
      else {
        this.answer.setValue(num);
      }
  }

}
